module.exports = "/virtual-football-league/img/jerseys/Red_And_White.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/jerseys/Red_And_White.png
// module id = 2242
// module chunks = 4